import { jsxs as c, jsx as t } from "react/jsx-runtime";
import { useBreakpoint as b, Breakpoints as u, NextgenImage as f, LoaderType as z, GenericLink as V, Button as C, ButtonStyles as k, Theme as w, ButtonSize as p, ButtonWidth as B } from "@nextgen-web-framework/all";
import { useState as N } from "react";
import v from "../SkeletonLoader/SkeletonLoader.js";
import '../../assets/HeroComponent.css';const y = "#ffffff", L = "#396e75", O = "#e5fdff", T = "#546223", G = "#f0fae5", S = "#a65523", W = "#fff1e8", x = "#7f3e3e", R = "#ffe2e2", D = "#62625a", I = "#f8f8e7", P = "#38539a", Y = "#707070", A = "#c8f8d1", E = "#87c9c8", M = "#5291b1", U = "rgba(82, 145, 177, 0.1019607843)", j = "#445685", F = "#181d61", H = "rgba(24, 29, 97, 0.1019607843)", K = "#5969d6", $ = "#ea999d", q = "#b6577e", J = "rgba(182, 87, 126, 0.1019607843)", Q = "#7e3e80", X = "#1e247f", Z = "rgba(30, 36, 127, 0.1019607843)", oo = "#da7600", eo = "#107f47", to = "#d91734", ro = "_html_5o1rb_38", e = {
  amwayWhite: y,
  darkBlue: L,
  lightBlue: O,
  darkGreen: T,
  lightGreen: G,
  darkOrange: S,
  lightOrange: W,
  darkRed: x,
  lightRed: R,
  darkYellow: D,
  lightYellow: I,
  darkPurple: P,
  darkGrayOnWhite: Y,
  dataVizColor1: A,
  dataVizColor2: E,
  dataVizColor3: M,
  dataVizColor3Background: U,
  dataVizColor4: j,
  dataVizColor5: F,
  dataVizColor5Background: H,
  dataVizColor6: K,
  dataVizColor7: $,
  dataVizColor8: q,
  dataVizColor8Background: J,
  dataVizColor9: Q,
  dataVizColor10: X,
  dataVizColor10Background: Z,
  dataVizAlertOrange: oo,
  dataVizSuccessGreen: eo,
  dataVizWarningRed: to,
  "no-visible": "_no-visible_5o1rb_34",
  html: ro,
  "hero-container": "_hero-container_5o1rb_72",
  "img-container": "_img-container_5o1rb_77",
  "hero-banner-image": "_hero-banner-image_5o1rb_83",
  "hero-banner-image-hidden": "_hero-banner-image-hidden_5o1rb_88",
  "img-without-footer": "_img-without-footer_5o1rb_91",
  "hero-footer-container": "_hero-footer-container_5o1rb_102",
  "hero-content-container": "_hero-content-container_5o1rb_114",
  "hero-title": "_hero-title_5o1rb_123",
  "hero-content": "_hero-content_5o1rb_114",
  "hero-source-and-time": "_hero-source-and-time_5o1rb_151",
  "hero-button-container": "_hero-button-container_5o1rb_160",
  "hero-button-link-wrapper": "_hero-button-link-wrapper_5o1rb_199"
}, lo = (a) => {
  const s = b(), m = [u.MD].includes(s), r = a == null ? void 0 : a.images.find((l) => l == null ? void 0 : l.viewport.includes(s)), { heroTitle: n, heroDescription: i, tagline: d, ctaButton: o } = a, h = !!n || !!i || !!d || !!(o != null && o.text), [g, _] = N(!0);
  return /* @__PURE__ */ c("div", { className: e["hero-container"], "data-testid": "hero-container-test-id", "data-pod-name": "commerce", children: [
    /* @__PURE__ */ c("div", { className: `${h ? e["img-container"] : e["img-without-footer"]}`, children: [
      /* @__PURE__ */ t(
        f,
        {
          src: (r == null ? void 0 : r.image.url) ?? "",
          className: g ? e["hero-banner-image-hidden"] : e["hero-banner-image"],
          onLoad: () => _(!1),
          alt: (r == null ? void 0 : r.alt_text) ?? "",
          loaderType: z.CONTENTSTACK
        }
      ),
      g && /* @__PURE__ */ t(v, { height: 562, borderRadius: 12 })
    ] }),
    h ? /* @__PURE__ */ c("div", { className: e["hero-footer-container"], children: [
      /* @__PURE__ */ c("div", { className: e["hero-content-container"], children: [
        n && n !== "" && /* @__PURE__ */ t("h2", { className: e["hero-title"], children: n }),
        i && i !== "" && /* @__PURE__ */ t("h6", { className: e["hero-content"], children: i }),
        d && d !== "" && /* @__PURE__ */ t("div", { className: e["hero-source-and-time"], children: d })
      ] }),
      o && (o == null ? void 0 : o.text) !== "" && /* @__PURE__ */ t("div", { className: e["hero-button-container"], children: /* @__PURE__ */ t(
        V,
        {
          href: o.url ?? "",
          target: o.target,
          className: e["hero-button-link-wrapper"],
          children: /* @__PURE__ */ t(
            C,
            {
              title: o == null ? void 0 : o.text,
              buttonStyle: k.SOLID,
              theme: w.PURPLE,
              size: p.MEDIUM,
              "data-testid": "hero-banner-btn",
              "data-pod-name": "commerce",
              buttonWidth: m ? B.FULL_WIDTH : void 0
            }
          )
        }
      ) })
    ] }) : ""
  ] });
};
export {
  lo as default
};
//# sourceMappingURL=HeroComponent.js.map
